/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {reorderUnitPosAdditionalImages} from '../api'

export const useMutationReorderUnitPosAdditionalImages = createReactQueryMutationHook('reorderUnitPosAdditionalImages', reorderUnitPosAdditionalImages)
